import { Controller } from "@stimulus/core"
import { isPreview } from "../support"

export default class extends Controller {
  connect() {
    if (isPreview()) {
      return false;
    }

    // Добавляем обработчик событий Select2
    $(this.element).on('select2:select select2:unselect select2:clear', (e) => {
      const form = this.element.closest('form');
      if (form) {
        // Используем Turbo для отправки формы, если доступен
        if (typeof Turbo !== 'undefined') {
          Turbo.navigator.submitForm(form);
        } else {
          form.submit();
        }
      }
    });

    return true;
  }

  disconnect() {
    // Удаляем обработчики событий при отключении контроллера
    $(this.element).off('select2:select select2:unselect select2:clear');
  }
}